import { call, put, takeEvery } from "redux-saga/effects";
import { addTemplateFail, addTemplateSuccess, deleteTemplateFail, deleteTemplateSuccess, getTemplatesListFail, getTemplatesListSuccess } from "./actions";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
import { ADD_TEMPLATE, DELETE_TEMPLATE, GET_TEMPLATES_LIST } from "./actionTypes";
import { onGettingTemplateList, onAddingTemplateList, onDeletingTemplateList } from "helpers/fakebackend_helper";

const toastTitle = "Template";

function* onGet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTemplateList, data);
    yield call(responseHandler, toastTitle, response, getTemplatesListSuccess, getTemplatesListFail, onSuccess, onError, false);
  } catch (err) {
    onError();
    yield put(getTemplatesListFail(err));
    showToast("error", toastTitle, err);
  }
}

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingTemplateList, data);
    yield call(responseHandler, toastTitle, response, deleteTemplateSuccess, deleteTemplateFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(deleteTemplateFail(err));
    showToast("error", toastTitle, err);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingTemplateList, data);
    yield call(responseHandler, toastTitle, response, addTemplateSuccess, addTemplateFail, onSuccess, onError);
  } catch (err) {
    onError();
    yield put(addTemplateFail(err));
    showToast("error", toastTitle, err);
  }
}

function* TemplateSaga() {
  yield takeEvery(GET_TEMPLATES_LIST, onGet);
  yield takeEvery(ADD_TEMPLATE, onAdd);
  yield takeEvery(DELETE_TEMPLATE, onDelete);
}

export default TemplateSaga;
